import React, { useState } from "react";
import { Card, CardHeader, Col, Collapse, Container, Table } from "reactstrap";
import moment from "moment";

export const Gestion = ({ gestion }) => {
    const [open, setOpen] = useState(false);

    const openCollapse = () => {
        setOpen(!open);
    };

    return (
        <div aria-multiselectable={true} className="card-collapse">
            <Card className="card-plain my-0">
                <CardHeader role="tab">
                    <div data-toggle="collapse" className="expanded c-pointer" onClick={openCollapse}>
                        {"Gestión"}&nbsp;&nbsp;
                        <i
                            className={
                                !open ? "now-ui-icons arrows-1_minimal-down" : "now-ui-icons arrows-1_minimal-up"
                            }
                        />
                    </div>
                </CardHeader>
                <Collapse isOpen={open}>
                    <Container className="text-center pl-0">
                        <Col className={"table-responsive"}>
                            <React.Fragment>
                                <Table className="adjusttd text-center">
                                    <thead className="text-primary">
                                        <tr>
                                            <th className="text-left">Item</th>
                                            <th className="text-left">Fecha</th>
                                            <th className="text-left">Inspector / Agente</th>
                                            <th className="text-left">Lugar / Acción</th>
                                            <th className="text-left">Gestión / Observaciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {gestion.length === 0 ? (
                                            <React.Fragment>
                                                <tr>
                                                    <td colSpan={6}>
                                                        <span>No hay información disponible.</span>
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment>
                                                {gestion.map((item, index) => (
                                                    <tr key={item.cdCobertura}>
                                                        <td className="text-left">
                                                            <span>{index + 1}</span>
                                                        </td>
                                                        <td className="text-left">
                                                            <span>
                                                                {item.fcInspeccion
                                                                    ? moment(item.fcInspeccion)
                                                                          .locale("moment/locale/es")
                                                                          .local()
                                                                          .format("DD/MMM/YYYY")
                                                                    : null}
                                                            </span>
                                                        </td>
                                                        <td className="text-left">
                                                            <span>{item.inspector}</span>
                                                        </td>
                                                        <td className="text-left">
                                                            <span>{item.lugar}</span>
                                                        </td>
                                                        <td className="text-left">
                                                            <span>{item.observaciones}</span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </React.Fragment>
                                        )}
                                    </tbody>
                                </Table>
                            </React.Fragment>
                        </Col>
                    </Container>
                </Collapse>
            </Card>
        </div>
    );
};
